import { useQuery } from "@tanstack/react-query";
import { useSelector } from "../../../../../store/store";
import { HOChangePersonRequestService } from "../../../../../services/human-organization/change-person-request.service";

export const useGetMyApprovals = () => {
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const response = useQuery({
    queryKey: ["my-approvals-change-person", currentUserName],
    queryFn: () =>
      HOChangePersonRequestService.getChangePersonRequests(currentUserName, ""),
    refetchOnMount: "always",
  });

  return response;
};
